// library imports
import Vue from 'vue'
import Vuex from 'vuex'

// store functionality
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
